(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["casebang-back-to-school-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const hydrateCardImages = (card) => {
      card.querySelectorAll('img[data-bts-src]').forEach((image) => {
        if (image.dataset.btsSrcset) {
          image.srcset = image.dataset.btsSrcset;
          image.removeAttribute('data-bts-srcset');
        }
        image.src = image.dataset.btsSrc;
        image.removeAttribute('data-bts-src');
      });
    };

    const activateSeries = (root, series) => {
      root.querySelectorAll('[data-bts-filter]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.btsFilter === series));
      });

      root.querySelectorAll('[data-bts-series]').forEach((card) => {
        const isActive = card.dataset.btsSeries === series;
        card.hidden = !isActive;
        if (isActive) {
          hydrateCardImages(card);
        }
      });
    };

    const copyDiscountCode = async (button) => {
      const code = button.dataset.btsCopyCode;
      const label = button.querySelector('[data-bts-copy-label]');
      if (!code || !label) {
        return;
      }

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
        } else {
          const field = document.createElement('textarea');
          field.value = code;
          field.setAttribute('readonly', '');
          field.style.position = 'fixed';
          field.style.opacity = '0';
          document.body.appendChild(field);
          field.select();
          document.execCommand('copy');
          field.remove();
        }

        label.textContent = label.dataset.successLabel;
        window.setTimeout(() => {
          label.textContent = label.dataset.defaultLabel;
        }, 1800);
      } catch {
        label.textContent = label.dataset.defaultLabel;
      }
    };

    document.addEventListener('click', (event) => {
      const copyButton = event.target.closest('[data-bts-copy-code]');
      if (copyButton) {
        copyDiscountCode(copyButton);
        return;
      }

      const button = event.target.closest('[data-bts-filter]');
      const root = button?.closest('[data-bts-filter-section]');
      if (button && root) {
        activateSeries(root, button.dataset.btsFilter);
      }
    });

    document.addEventListener('shopify:block:select', (event) => {
      const card = event.target.closest('[data-bts-series]');
      const root = card?.closest('[data-bts-filter-section]');
      if (card && root) {
        activateSeries(root, card.dataset.btsSeries);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casebang-copy-code"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const copyText = async (value) => {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(value);
        return;
      }

      const input = document.createElement('textarea');
      input.value = value;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    };

    const init = (root = document) => {
      root.querySelectorAll('.cb-copy-code__button').forEach((button) => {
        if (button.dataset.copyReady === 'true') return;
        button.dataset.copyReady = 'true';

        button.addEventListener('click', async () => {
          const code = button.dataset.copyCode || '';
          const action = button.querySelector('[data-copy-action]');
          const status = button.closest('.cb-copy-code__inner')?.querySelector('[data-copy-status]');

          try {
            await copyText(code);
            button.classList.add('is-copied');
            if (action) action.textContent = button.dataset.copiedLabel || 'Copied';
            if (status) status.textContent = button.dataset.copiedLabel || 'Copied';

            window.setTimeout(() => {
              button.classList.remove('is-copied');
              if (action) action.textContent = button.dataset.copyLabel || 'Copy code';
            }, 1800);
          } catch (error) {
            if (status) status.textContent = code;
          }
        });
      });
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casebang-promo-countdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (value) => String(value).padStart(2, '0');

    const showPhaseTwo = (section, timer) => {
      if (section.dataset.promoPhase === 'two') return;
      section.dataset.promoPhase = 'two';

      const eyebrow = section.querySelector('.cb-promo-countdown__eyebrow');
      const heading = section.querySelector('.cb-promo-countdown__heading');
      const text = section.querySelector('.cb-promo-countdown__text');
      const button = section.querySelector('.cb-promo-countdown__button');
      const buttonLabel = button?.querySelector('span:first-child');

      if (eyebrow) eyebrow.textContent = section.dataset.phaseTwoEyebrow;
      if (heading) heading.textContent = section.dataset.phaseTwoHeading;
      if (text) text.textContent = section.dataset.phaseTwoText;
      if (buttonLabel) buttonLabel.textContent = section.dataset.phaseTwoButtonLabel;
      if (button) button.href = section.dataset.phaseTwoButtonUrl;

      timer.hidden = true;
      timer.setAttribute('aria-hidden', 'true');
    };

    const startCountdown = (section, timer) => {
      if (timer.dataset.countdownReady === 'true') return;
      timer.dataset.countdownReady = 'true';

      const switchAtUtc = section.dataset.switchAtUtc;
      const target = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/.test(switchAtUtc)
        ? Date.parse(switchAtUtc)
        : Number.NaN;
      const units = timer.querySelector('.cb-promo-countdown__units');
      const ended = timer.querySelector('[data-ended]');

      if (!Number.isFinite(target)) {
        if (units) units.hidden = true;
        if (ended) {
          ended.hidden = false;
          ended.textContent = 'Set switch time in UTC';
        }
        return;
      }

      const render = () => {
        const distance = target - Date.now();

        if (distance <= 0) {
          showPhaseTwo(section, timer);
          return false;
        }

        const days = Math.floor(distance / 86400000);
        const hours = Math.floor((distance % 86400000) / 3600000);
        const minutes = Math.floor((distance % 3600000) / 60000);
        const seconds = Math.floor((distance % 60000) / 1000);

        timer.querySelector('[data-days]').textContent = pad(days);
        timer.querySelector('[data-hours]').textContent = pad(hours);
        timer.querySelector('[data-minutes]').textContent = pad(minutes);
        timer.querySelector('[data-seconds]').textContent = pad(seconds);
        return true;
      };

      if (render()) {
        const interval = window.setInterval(() => {
          if (!render()) window.clearInterval(interval);
        }, 1000);
      }
    };

    const init = (root = document) => {
      root.querySelectorAll('.cb-promo-countdown').forEach((section) => {
        const timer = section.querySelector('[data-casebang-promo-countdown]');
        if (timer) startCountdown(section, timer);
      });
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
// =========
class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.trans = this.dataset.trans;
  }
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
    this.onScroll();
  }
  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom || scrollTop > this.header.offsetHeight) {
      this.header.classList.add('scrolled-past-header');
      if(this.trans != 'false') this.classList.remove('transparent_header');
      document.body.classList.add('sticky-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom || scrollTop > this.header.offsetHeight) {
      this.header.classList.add('scrolled-past-header');
      if(this.trans != 'false') this.classList.remove('transparent_header');
      document.body.classList.add('sticky-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top || scrollTop < this.header.offsetHeight) {
      this.header.classList.remove('scrolled-past-header');
      if(this.trans != 'false') this.classList.add('transparent_header');
      document.body.classList.remove('sticky-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }
  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }
  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }
  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iphone18-early-access-before-launch-offers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const openDialog = (dialog) => {
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    };

    const closeDialog = (dialog) => {
      if (!dialog) return;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    };

    if (!window.__cb18EarlyAccessClickBound) {
      window.__cb18EarlyAccessClickBound = true;

      document.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-cb18-open]');
        if (opener) {
          openDialog(document.getElementById(`cb18-dialog-${opener.dataset.cb18Open}`));
          return;
        }

        const closer = event.target.closest('[data-cb18-close]');
        if (closer) {
          closeDialog(closer.closest('dialog'));
          return;
        }

        if (event.target.matches('.cb18-dialog')) {
          closeDialog(event.target);
        }
      });
    }

    const revealFormState = () => {
      document.querySelectorAll('.cb18-dialog [data-cb18-form-error]').forEach((state) => {
        openDialog(state.closest('dialog'));
      });

      document.querySelectorAll('.cb18-dialog [data-cb18-form-success]').forEach((state) => {
        const existingToast = document.querySelector('.cb18-toast');
        if (existingToast) existingToast.remove();

        const toast = document.createElement('div');
        toast.className = 'cb18-toast';
        toast.setAttribute('role', 'status');
        toast.textContent = state.textContent.trim();
        document.body.appendChild(toast);

        window.setTimeout(() => toast.remove(), 3600);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', revealFormState, { once: true });
    } else {
      revealFormState();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iphone18-early-access"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const openDialog = (dialog) => {
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    };

    const closeDialog = (dialog) => {
      if (!dialog) return;
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    };

    if (!window.__cb18EarlyAccessClickBound) {
      window.__cb18EarlyAccessClickBound = true;

      document.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-cb18-open]');
        if (opener) {
          openDialog(document.getElementById(`cb18-dialog-${opener.dataset.cb18Open}`));
          return;
        }

        const closer = event.target.closest('[data-cb18-close]');
        if (closer) {
          closeDialog(closer.closest('dialog'));
          return;
        }

        if (event.target.matches('.cb18-dialog')) {
          closeDialog(event.target);
        }
      });
    }

    const revealFormState = () => {
      document.querySelectorAll('.cb18-dialog [data-cb18-form-error]').forEach((state) => {
        openDialog(state.closest('dialog'));
      });

      document.querySelectorAll('.cb18-dialog [data-cb18-form-success]').forEach((state) => {
        const existingToast = document.querySelector('.cb18-toast');
        if (existingToast) existingToast.remove();

        const toast = document.createElement('div');
        toast.className = 'cb18-toast';
        toast.setAttribute('role', 'status');
        toast.textContent = state.textContent.trim();
        document.body.appendChild(toast);

        window.setTimeout(() => toast.remove(), 3600);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', revealFormState, { once: true });
    } else {
      revealFormState();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
